import axios from 'axios'
import { setupAuthInterceptor } from '@/lib/authInterceptor'

const baseURL = `${import.meta.env.VITE_LOCAL_AI_API_BASE_URL || 'https://ai.hocnhe.com'}/v1/admin/reading-authoring`
const client = axios.create({ baseURL, timeout: 30_000, headers: { 'Content-Type': 'application/json' } })
setupAuthInterceptor(client)

export type WorkflowStatus = 'queued' | 'running' | 'preview_ready' | 'succeeded' | 'failed' | 'cancelled'
export interface ReadingWorkflowJob {
  id: string
  sentence_id: string
  status: WorkflowStatus
  stage: string
  stage_index: number
  progress: number
  error?: string
  attempt: number
  created_at: string
  started_at?: string
  finished_at?: string
  phase: 'preview' | 'enrich'
  workspace_path: string
}
export interface ReadingPreview { title: string; sentences: Array<{ text: string }> }
export interface CreateReadingWorkflowInput {
  topic: string
  level: string
  content_type: string
  content: string
}

interface Envelope<T> { success: boolean; message?: string; data?: T }

function data<T>(response: { data: Envelope<T> }, fallback: string): T {
  if (response.data.success && response.data.data !== undefined) return response.data.data
  throw new Error(response.data.message || fallback)
}

export const readingWorkflowApi = {
  async list() { return data(await client.get<Envelope<ReadingWorkflowJob[]>>('/jobs'), 'Không thể tải danh sách workflow') },
  async create(input: CreateReadingWorkflowInput) { return data(await client.post<Envelope<ReadingWorkflowJob>>('/jobs', input), 'Không thể tạo workflow') },
  async preview(id: string) { return data(await client.get<Envelope<ReadingPreview>>(`/jobs/${id}/preview`), 'Preview chưa sẵn sàng') },
  async approve(id: string) { return data(await client.post<Envelope<ReadingWorkflowJob>>(`/jobs/${id}/approve`), 'Không thể phê duyệt preview') },
  async regenerate(id: string) { return data(await client.post<Envelope<ReadingWorkflowJob>>(`/jobs/${id}/regenerate`), 'Không thể tạo lại preview') },
  async retry(id: string) { return data(await client.post<Envelope<ReadingWorkflowJob>>(`/jobs/${id}/retry`), 'Không thể chạy lại workflow') },
  async cancel(id: string) { return data(await client.post<Envelope<ReadingWorkflowJob>>(`/jobs/${id}/cancel`), 'Không thể hủy workflow') },
}
